import React, { ReactNode, FC, ChangeEvent, useState } from 'react';
import { Grid, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LargeTab, TextTransform } from 'components';
import { UseCheckedState } from 'types/app';
import { useTranslation } from 'react-i18next';

interface Props extends Partial<UseCheckedState> {
  actions?: ReactNode;
  active: boolean;
  onSetActive: (state: boolean) => void;
}

enum TabValues {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}));

const TableHeader: FC<Props> = ({ actions, active, onSetActive, hasChecked }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [tab, setTab] = useState(active ? TabValues.Enabled : TabValues.Disabled);

  function handleTabChange(event: ChangeEvent, value: TabValues) {
    setTab(value);
    onSetActive(value === TabValues.Enabled);
  }

  return (
    <div className={classes.root}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <Tabs value={tab} onChange={handleTabChange}>
            <LargeTab
              label={<TextTransform transform="capitalize">{t('common:enabled')}</TextTransform>}
              value={TabValues.Enabled}
            />
            <LargeTab
              label={<TextTransform transform="capitalize">{t('common:disabled')}</TextTransform>}
              value={TabValues.Disabled}
            />
          </Tabs>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" justify="flex-end" spacing={3}>
            <Grid item>{hasChecked && actions}</Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default TableHeader;
